{
	"adaptiveCropTitle": "Adaptive Crop and Straighten",
	"adaptiveCropMain": "When you include crop or straighten changes in a Reference Edit, similar photos will inherit matching adjustments. You can change this in Settings.",
	"adaptiveHealingTitle": "Adaptive Healing",
	"adaptiveHealingMain": "When you include healing in a Reference Edit, similar photos will inherit matching healed areas. You can change this in Settings.",
	"adaptiveMaskingTitle": "Adaptive Masking",
	"adaptiveMaskingMain": "When you include masks in a Reference Edit, similar photos will inherit matching masked areas and settings. You can change this in Settings.",
	"adaptivePerspectiveTitle": "Adaptive Perspective Correction",
	"adaptivePerspectiveMain": "When you include perspective correction in a Reference Edit, similar photos will inherit matching adjustments. You can change this in Settings.",
	"ariaNextAiSuggestion": "Next AI Suggestion",
	"ariaPhotoReferenceControls": "Photo Reference Controls",
	"ariaPreviousAiSuggestion": "Previous AI Suggestion",
	"bestResultsHint": "For the best results, edit and mark {{count}} photos as references using the toggle below.",
	"descLockEdit": "Prevent AI from editing this photo again",
	"descMarkReference": "AI will use this temporary reference edit to improve similar photos in this project.",
	"lockEdit": "Lock Edit",
	"lockEditTooltipMain": "If you want to prevent AI from editing this photo again, turn on Lock Edit.",
	"lockEditTooltipTitle": "Lock Edit",
	"markFirstReferenceTitle": "Mark First Reference Edit",
	"markFirstReferenceMain": "Start your AI Style by marking the first reference edit once you're happy with your edit.",
	"markReferenceEdit": "Mark Reference Edit",
	"markReferenceMain": "Once you finish your edit, use this toggle to mark it as a Reference.",
	"markReferenceTitle": "Mark Reference",
	"markReferenceEditTitle": "Mark Reference Edit",
	"markReferenceEditMain": "You can fine-tune this photo and add it as a new reference. Your AI Style will adjust your album right away.",
	"nextSuggestion": "Next Suggestion",
	"prevSuggestion": "Prev Suggestion",
	"setupProgress": "Setup Progress"
}
